var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHashtagBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2667 6.96667H8.4524L8.79083 4.03333H10.2667C10.6718 4.03333 11 3.70517 11 3.3C11 2.89483 10.6718 2.56667 10.2667 2.56667H8.95987L9.16153 0.8173C9.2114 0.388667 8.87847 0 8.43333 0C8.06667 0 7.74803 0.274633 7.70477 0.649367L7.48367 2.56667H4.19357L4.39523 0.8173C4.44473 0.388667 4.1118 0 3.66667 0C3.3 0 2.98137 0.274633 2.9381 0.649367L2.717 2.56667H0.733333C0.328167 2.56667 0 2.89483 0 3.3C0 3.70517 0.328167 4.03333 0.733333 4.03333H2.5476L2.20917 6.96667H0.733333C0.328167 6.96667 0 7.29483 0 7.7C0 8.10517 0.328167 8.43333 0.733333 8.43333H2.04013L1.83847 10.1827C1.7919 10.5849 2.09917 11 2.56667 11C2.9392 11 3.25197 10.7246 3.29523 10.3506L3.51633 8.43333H6.80643L6.60477 10.1827C6.55857 10.5849 6.86583 11 7.33333 11C7.70587 11 8.01863 10.7246 8.0619 10.3506L8.283 8.43333H10.2667C10.6718 8.43333 11 8.10517 11 7.7C11 7.29483 10.6718 6.96667 10.2667 6.96667ZM3.68573 6.96667L4.02417 4.03333H7.31427L6.97583 6.96667H3.68573Z",
    fill: "#155EEF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHashtagBlue);
export default __webpack_public_path__ + "static/media/hashtag-blue.bc395da582089209a6e94e75bae790c8.svg";
export { ForwardRef as ReactComponent };